export default {
  title: 'Suivre votre commande',
  text: "Merci d'avoir commandé ici ! Notre partenariat <0>{{carrier}}</0> nous permet de gérer les livraisons directement sur notre site, nous économisant en moyenne {{savings}} en commissions de livraison. Votre commande sera livrée par <1>{{carrier}}</1>, garantissant un excellent service 😊",
  labels: {
    delivered_by: 'Livré par',
  },
  buttons: {
    track_order: 'Suivre la commande en direct →',
    track_order_once_confirmed: 'Suivre la commande en direct une fois confirmée',
  },
};
